import { render } from "./quote-files.vue?vue&type=template&id=2756729b&scoped=true"
import script from "./quote-files.vue?vue&type=script&lang=js"
export * from "./quote-files.vue?vue&type=script&lang=js"

import "./quote-files.vue?vue&type=style&index=0&id=2756729b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2756729b"]])

export default __exports__